/* eslint-disable */
import { Text, TextInput, Dimensions } from 'react-native'
import DebugConfig from './DebugConfig'
import AppConfig from './AppConfig'

// Allow/disallow font-scaling in app
// broken in react-native 0.59.9, comment out for now
//Text.defaultProps.allowFontScaling = AppConfig.allowTextFontScaling

let {width, height} = Dimensions.get('window')

let maxScale = 1.0
if (width === 320) maxScale = 1.0 // SEs
else if (width === 375) maxScale = 1.2 // 6,7,8
else maxScale = 1.2 // big & tall

if (Text.defaultProps == null) Text.defaultProps = {};
//Text.defaultProps.allowFontScaling = false;
Text.defaultProps.maxFontSizeMultiplier = maxScale;
if (TextInput.defaultProps == null) TextInput.defaultProps = {};
//TextInput.defaultProps.allowFontScaling = false;
TextInput.defaultProps.maxFontSizeMultiplier = maxScale;

if (__DEV__) {
  // If ReactNative's yellow box warnings are too much, it is possible to turn
  // it off, but the healthier approach is to fix the warnings.  =)
  console.disableYellowBox = !DebugConfig.yellowBox
}
